import React, { useMemo, useState } from "react";
import {
  faWallet,
  faCoins,
  faGift,
  faTrophy,
  faQrcode,
  faShareNodes,
  faReceipt,
  faCalendarCheck,
  faArrowTrendUp,
  faStar,
  faCrown,
  faBolt,
  faBook,
  faPen,
  faGraduationCap,
  faCartShopping,
  faMedal,
  faCircleCheck,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import QRCode from "react-qr-code";

const ScoreKartHome = () => {
  const [activeTab, setActiveTab] = useState("all");

  /* =========================================================
      MOCK USER
  ========================================================= */

  const user = {
    name: "Sanjeev Kumar",
    code: "T5W-EX-2048",
    totalPoints: 4820,
    redeemablePoints: 3200,
    rank: 12,
    streak: 8,
  };

  /* =========================================================
      MOCK PURCHASES
  ========================================================= */

  const recentPurchases = [
    {
      id: 1,
      item: "Exam Practice Notebook Set",
      points: 120,
      amount: 499,
      date: "10 May 2026",
      icon: faBook,
    },
    {
      id: 2,
      item: "Premium Gel Pen Kit",
      points: 80,
      amount: 299,
      date: "08 May 2026",
      icon: faPen,
    },
    {
      id: 3,
      item: "Student Combo Pack",
      points: 240,
      amount: 999,
      date: "04 May 2026",
      icon: faGraduationCap,
    },
  ];

  /* =========================================================
      REWARDS
  ========================================================= */

  const rewards = [
    {
      id: 1,
      title: "₹100 Stationery Voucher",
      points: 1000,
      badge: "Popular",
    },
    {
      id: 2,
      title: "Mock Test Unlock",
      points: 1500,
      badge: "Student Favorite",
    },
    {
      id: 3,
      title: "ExamUnion Premium Access",
      points: 3000,
      badge: "Premium",
    },
    {
      id: 4,
      title: "Scholarship Lucky Draw",
      points: 5000,
      badge: "Limited",
    },
  ];

  /* =========================================================
      LEADERBOARD
  ========================================================= */

  const leaderboard = [
    {
      id: 1,
      name: "Riya Sharma",
      points: 15420,
      rank: 1,
    },
    {
      id: 2,
      name: "Aman Verma",
      points: 12880,
      rank: 2,
    },
    {
      id: 3,
      name: "Priyanshu",
      points: 11750,
      rank: 3,
    },
    {
      id: 4,
      name: "You",
      points: 4820,
      rank: 12,
    },
  ];

  /* =========================================================
      REDEEM HISTORY
  ========================================================= */

  const redeemHistory = [
    {
      id: 1,
      item: "₹100 Voucher",
      points: 1000,
      date: "01 May 2026",
      status: "Processed",
    },
    {
      id: 2,
      item: "Premium Mock Test",
      points: 1500,
      date: "21 Apr 2026",
      status: "Delivered",
    },
  ];

  /* =========================================================
      ELIGIBLE EVENTS
  ========================================================= */

  const events = [
    {
      id: 1,
      title: "JEE Mega Scholarship Event",
      status: "Eligible",
      icon: faGraduationCap,
    },
    {
      id: 2,
      title: "Summer Reward Bonanza",
      status: "Upcoming",
      icon: faGift,
    },
    {
      id: 3,
      title: "Exam Achievers League",
      status: "Active",
      icon: faTrophy,
    },
  ];

  /* =========================================================
      SHARE
  ========================================================= */

  const referralLink = `https://www.think5whys.com/scorekart?ref=${user.code}`;

  const handleShare = async () => {
    const shareText = `
🎓 ScoreKart Rewards

Earn points on stationery purchases.
Redeem exciting rewards after eligible events.

Referral Code: ${user.code}

Join Here:
${referralLink}
`;

    try {
      if (navigator.share) {
        await navigator.share({
          title: "ScoreKart",
          text: shareText,
          url: referralLink,
        });
      } else {
        await navigator.clipboard.writeText(shareText);
        alert("Referral copied!");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDownload = () => {
    window.print();
  };

  const filteredRewards = useMemo(() => {
    if (activeTab === "all") return rewards;
    if (activeTab === "redeemable") {
      return rewards.filter(
        (reward) => reward.points <= user.redeemablePoints
      );
    }
    return rewards;
  }, [activeTab]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white px-3 py-4">

      {/* =========================================================
          HERO
      ========================================================= */}

      <div className="rounded-3xl p-5 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 shadow-2xl">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">

          <div>
            <h1 className="text-3xl font-black tracking-tight">
              🛒 ScoreKart
            </h1>

            <p className="text-sm text-white/90 mt-2 max-w-xl">
              Earn reward points on stationery purchases and redeem them
              after qualifying events, competitions, and academic milestones.
            </p>

            <div className="flex flex-wrap gap-2 mt-4">

              <div className="bg-white/20 px-3 py-1 rounded-full text-xs">
                🎓 Student Rewards
              </div>

              <div className="bg-white/20 px-3 py-1 rounded-full text-xs">
                ⭐ Redeem Benefits
              </div>

              <div className="bg-white/20 px-3 py-1 rounded-full text-xs">
                🏆 Event-Based Redemption
              </div>

            </div>
          </div>

          <div className="bg-white rounded-2xl p-3">
            <QRCode
              value={referralLink}
              size={120}
              style={{
                height: "auto",
                maxWidth: "100%",
                width: "120px",
              }}
            />
          </div>

        </div>
      </div>

      {/* =========================================================
          WALLET CARDS
      ========================================================= */}

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-4">

        <div className="bg-slate-900 border border-cyan-500 rounded-3xl p-4">
          <div className="flex items-center justify-between text-cyan-100">
            <FontAwesomeIcon icon={faWallet} className="text-cyan-300 text-xl" />
            <span className="text-xs text-gray-400">Wallet</span>
          </div>

          <h2 className="text-2xl font-black mt-3 text-yellow-200">
            {user.totalPoints}
          </h2>

          <p className="text-xs text-gray-100 mt-1">
            Total ScorePoints
          </p>
        </div>

        <div className="bg-slate-900 border border-yellow-500 rounded-3xl p-4">
          <div className="flex items-center justify-between">
            <FontAwesomeIcon icon={faCoins} className="text-yellow-300 text-xl" />
            <span className="text-xs text-gray-100">Redeemable</span>
          </div>

          <h2 className="text-2xl font-black mt-3 text-yellow-200">
            {user.redeemablePoints}
          </h2>

          <p className="text-xs text-gray-100 mt-1">
            Eligible Points
          </p>
        </div>

        <div className="bg-slate-900 border border-pink-500 rounded-3xl p-4">
          <div className="flex items-center justify-between">
            <FontAwesomeIcon icon={faTrophy} className="text-pink-300 text-xl" />
            <span className="text-xs text-yellow-200">Rank</span>
          </div>

          <h2 className="text-2xl font-black mt-3 text-yellow-200">
            #{user.rank}
          </h2>

          <p className="text-xs text-gray-100 mt-1">
            National Rank
          </p>
        </div>

        <div className="bg-slate-900 border border-green-500 rounded-3xl p-4">
          <div className="flex items-center justify-between">
            <FontAwesomeIcon icon={faBolt} className="text-green-200 text-xl" />
            <span className="text-xs text-gray-100">Streak</span>
          </div>

          <h2 className="text-2xl font-black mt-3 text-yellow-200">
            {user.streak} Days
          </h2>

          <p className="text-xs text-gray-100 mt-1">
            Learning Activity
          </p>
        </div>

      </div>

      {/* =========================================================
          MAIN GRID
      ========================================================= */}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4">

        {/* =====================================================
            PURCHASES
        ===================================================== */}

        <div className="lg:col-span-2 bg-slate-900 rounded-3xl border border-slate-700 p-4">

          <div className="flex items-center justify-between mb-4 text-cyan-300">
            <h3 className="font-bold text-lg text-cyan-200">
              <FontAwesomeIcon icon={faReceipt} className="mr-2 text-cyan-300" />
              Recent Purchases
            </h3>

            <div className="text-xs text-gray-100">
              Last 30 days
            </div>
          </div>

          <div className="space-y-3">

            {recentPurchases.map((purchase) => (
              <div
                key={purchase.id}
                className="bg-slate-800 rounded-2xl p-3 flex items-center justify-between"
              >
                <div className="flex items-center gap-3">

                  <div className="w-12 h-12 rounded-2xl bg-cyan-500/20 flex items-center justify-center">
                    <FontAwesomeIcon
                      icon={purchase.icon}
                      className="text-cyan-300"
                    />
                  </div>

                  <div>
                    <h4 className="font-semibold text-sm text-gray-50">
                      {purchase.item}
                    </h4>

                    <p className="text-xs text-gray-100">
                      {purchase.date}
                    </p>
                  </div>

                </div>

                <div className="text-right">
                  <p className="font-bold text-yellow-100">
                    +{purchase.points}
                  </p>

                  <p className="text-xs text-gray-100">
                    ₹{purchase.amount}
                  </p>
                </div>
              </div>
            ))}

          </div>
        </div>

        {/* =====================================================
            QR + REFERRAL
        ===================================================== */}

        <div className="bg-slate-900 rounded-3xl border border-slate-700 p-4">

          <h3 className="font-bold text-lg mb-4 text-yellow-200">
            <FontAwesomeIcon icon={faShareNodes} className="mr-2 text-green-300" />
            Referral & QR
          </h3>

          <div className="bg-white rounded-2xl p-3 flex justify-center">
            <QRCode
              value={referralLink}
              size={180}
            />
          </div>

          <div className="mt-4 text-center">

            <p className="text-xs text-gray-400">
              Your Referral Code
            </p>

            <h2 className="text-xl font-black text-yellow-300 mt-1">
              {user.code}
            </h2>

          </div>

          <div className="grid grid-cols-2 gap-2 mt-4">

            <button
              type="button"
              onClick={handleShare}
              className="bg-green-500 hover:bg-green-600 py-2 rounded-xl font-semibold transition"
            >
              <FontAwesomeIcon icon={faShareNodes} />
              <span className="ml-2">Share</span>
            </button>

            <button
              type="button"
              onClick={handleDownload}
              className="bg-purple-500 hover:bg-purple-600 py-2 rounded-xl font-semibold transition"
            >
              <FontAwesomeIcon icon={faDownload} />
              <span className="ml-2">Save</span>
            </button>

          </div>

        </div>

      </div>

      {/* =========================================================
          REWARDS
      ========================================================= */}

      <div className="bg-slate-900 rounded-3xl border border-slate-700 p-4 mt-4">

        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 mb-4">

          <h3 className="font-bold text-lg text-pink-300">
            <FontAwesomeIcon icon={faGift} className="mr-2 text-pink-300" />
            Rewards Catalog
          </h3>

          <div className="flex gap-2">

            <button
              type="button"
              onClick={() => setActiveTab("all")}
              className={`px-3 py-1 rounded-full text-xs ${
                activeTab === "all"
                  ? "bg-cyan-500 text-black"
                  : "bg-slate-800"
              }`}
            >
              All
            </button>

            <button
              type="button"
              onClick={() => setActiveTab("redeemable")}
              className={`px-3 py-1 rounded-full text-xs ${
                activeTab === "redeemable"
                  ? "bg-yellow-400 text-black"
                  : "bg-slate-800"
              }`}
            >
              Redeemable
            </button>

          </div>

        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">

          {filteredRewards.map((reward) => (
            <div
              key={reward.id}
              className="bg-slate-800 rounded-2xl p-4 border border-slate-700"
            >
              <div className="flex items-center justify-between">

                <div>
                  <h4 className="font-bold text-gray-100">
                    {reward.title}
                  </h4>

                  <p className="text-xs text-gray-200 mt-1">
                    {reward.points} points required
                  </p>
                </div>

                <div className="bg-pink-500/20 text-pink-300 text-xs px-2 py-1 rounded-full">
                  {reward.badge}
                </div>

              </div>

              <button
                type="button"
                disabled={reward.points > user.redeemablePoints}
                className={`w-40 lg:w-64 text-xs lg:text-sm mt-4 py-2 rounded-xl font-semibold transition ${
                  reward.points <= user.redeemablePoints
                    ? "bg-yellow-400 hover:bg-yellow-300 text-black"
                    : "bg-slate-700 text-gray-400 cursor-not-allowed"
                }`}
              >
                {reward.points <= user.redeemablePoints
                  ? "Redeem Now"
                  : "Insufficient Points"}
              </button>
            </div>
          ))}

        </div>
      </div>

      {/* =========================================================
          LEADERBOARD + EVENTS + HISTORY
      ========================================================= */}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4">

        {/* LEADERBOARD */}

        <div className="bg-slate-900 rounded-3xl border border-slate-700 p-4">

          <h3 className="font-bold text-lg mb-4 text-yellow-200">
            <FontAwesomeIcon icon={faMedal} className="mr-2 text-yellow-300" />
            Leaderboard
          </h3>

          <div className="space-y-3">

            {leaderboard.map((item) => (
              <div
                key={item.id}
                className={`rounded-2xl p-3 flex items-center justify-between ${
                  item.name === "You"
                    ? "bg-cyan-500/20 border border-cyan-400"
                    : "bg-slate-800"
                }`}
              >
                <div className="flex items-center gap-3 text-white">

                  <div className="w-10 h-10 rounded-full bg-slate-700 flex items-center justify-center font-bold">
                    {item.rank === 1 ? (
                      <FontAwesomeIcon icon={faCrown} className="text-yellow-300" />
                    ) : (
                      item.rank
                    )}
                  </div>

                  <div>
                    <p className="font-semibold text-sm text-gray-100">
                      {item.name}
                    </p>

                    <p className="text-xs text-gray-400">
                      Rank #{item.rank}
                    </p>
                  </div>

                </div>

                <div className="text-yellow-300 font-bold">
                  {item.points}
                </div>
              </div>
            ))}

          </div>
        </div>

        {/* EVENTS */}

        <div className="bg-slate-900 rounded-3xl border border-slate-700 p-4">

          <h3 className="font-bold text-lg mb-4 text-yellow-200">
            <FontAwesomeIcon
              icon={faCalendarCheck}
              className="mr-2 text-green-300"
            />
            Eligible Events
          </h3>

          <div className="space-y-3">

            {events.map((event) => (
              <div
                key={event.id}
                className="bg-slate-800 rounded-2xl p-3"
              >
                <div className="flex items-center justify-between">

                  <div className="flex items-center gap-3">
                    <FontAwesomeIcon
                      icon={event.icon}
                      className="text-cyan-300"
                    />

                    <div>
                      <p className="font-semibold text-sm text-gray-100">
                        {event.title}
                      </p>

                      <p className="text-xs text-gray-400">
                        Reward Eligible
                      </p>
                    </div>
                  </div>

                  <div className="text-xs px-2 py-1 rounded-full bg-green-500/20 text-green-300">
                    {event.status}
                  </div>

                </div>
              </div>
            ))}

          </div>
        </div>

        {/* HISTORY */}

        <div className="bg-slate-900 rounded-3xl border border-slate-700 p-4">

          <h3 className="font-bold text-lg mb-4 text-yellow-200">
            <FontAwesomeIcon
              icon={faArrowTrendUp}
              className="mr-2 text-pink-300"
            />
            Redeem History
          </h3>

          <div className="space-y-3">

            {redeemHistory.map((history) => (
              <div
                key={history.id}
                className="bg-slate-800 rounded-2xl p-3"
              >
                <div className="flex items-start justify-between">

                  <div>
                    <p className="font-semibold text-sm text-gray-100">
                      {history.item}
                    </p>

                    <p className="text-xs text-gray-400 mt-1">
                      {history.date}
                    </p>
                  </div>

                  <div className="text-right">

                    <p className="text-yellow-300 font-bold text-sm">
                      -{history.points}
                    </p>

                    <div className="text-green-300 text-xs mt-1">
                      <FontAwesomeIcon
                        icon={faCircleCheck}
                        className="mr-1"
                      />
                      {history.status}
                    </div>

                  </div>

                </div>
              </div>
            ))}

          </div>
        </div>

      </div>

    </div>
  );
};

export default ScoreKartHome;